import React, {useEffect, useRef, useState} from 'react';
import {classNames} from 'utils';
import styles from './alert.module.css';

export const Alert = ({type, timeout, icon, children, onFinish = () => {}}: Props) => {
  const timeoutId = useRef<ReturnType<typeof setTimeout>>();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (timeout) {
      timeoutId.current = setTimeout(() => {
        onFinish();
        setVisible(false);
      }, timeout);
    }
    return () => clearTimeout(timeoutId.current);
  }, [type, timeout, children]);

  return visible ? (
    <div className={classNames([styles.alert, styles[type]])}>
      {icon}
      {children}
    </div>
  ) : null;
};

type Props = {
  type: 'error' | 'warning' | 'info' | 'success' | 'default';
  timeout?: number;
  onFinish?: () => void;
  icon?: JSX.Element;
  children?: React.ReactNode;
};
